import { useState,useEffect } from "react"
import axios from "../../../../api/axios"
import { useAuth } from "../../../../ContextApp/AuthContext"
import { isEmpty } from "../../../../Utilities/Utils"
import Swal from "sweetalert2"
function Deliberation(){
    const [sections,setSections]=useState([])
    const [section,setSection]=useState('')
    const [niveau,setNiveau]=useState('')
    const [isLoading,setIsLoading]=useState(false)
    const [type_critere,setType_critere]=useState('')
    const [pourcentage,setPourcentage]=useState('')
    const [nombrecours,setNombrecours]=useState()
    const [conduite,setConduite]=useState('')
    const [decision,setDecision]=useState('')
    const [critere2,setCritere2]=useState("")
    const {user}=useAuth()
    const [testpourcentage,setTestpourcentage]=useState("")
    const [testcours,setTestcours]=useState("")
    const [testnombreCour,setTestNombreCours]=useState("")
    

    const sectionnom=!isEmpty(sections) ? sections.find(sect=>sect.idsection===Number(section)) : ""
    console.log(sections)
    useEffect(()=>{
        handleSection()
    },[])
    
    function prefixe(niveau){
        if(!isEmpty(niveau)){
            return niveau==="1" ? "ère " : "ème "
        }
        return "";
    }
    function prefixecritere(critere2){
        //if(!isEmpty(critere)){
            switch(critere2){
                case "NombreReussite": return "des cours à réussir :";
                case "NombreEchec": return "d'échecs ";
                default: return ""
            }
      //  }
        
    }
    useEffect(()=>{
        prefixecritere(critere2)
    },[critere2])
    const csrf=async () => {
            return await axios.get('/sanctum/csrf-cookie');
    };

    const handleSection=async()=>{
            await csrf()
                await axios.get(`api/sectionorg/${user?.ecole?.id}`).then((res)=>{
                    setSections(res?.data?.items)
                }).catch((err)=>{
    
                })
        }
    const handleChangeSection=(e)=>{
         setSection(e.target.value)
         setNiveau("")
    }
    const handleSend=async()=>{
        setIsLoading(true)
        if(!isEmpty(critere2) && !isEmpty(testnombreCour) && !isEmpty(nombrecours) || isEmpty(critere2)){
            
            await axios.post("/api/Deliberation",{
            id_section:section,
            niveau:niveau,
            id_ecole:user?.ecole?.id,
            pourcentage:pourcentage,
            nombrecours:nombrecours,
            conduite:conduite,
            decision:decision,
            type_critere:critere2,
            testnombreCour:testnombreCour,
            testpourcentage:testpourcentage,
            annee_scolaire:user?.programme_scolaire?.annee_scolaire,
            userid:user?.id

        }).then((res)=>{
            setSection("")
            setNiveau("")
            setCritere2("")
            setTestNombreCours("")
            setTestpourcentage("")
            setNombrecours("")
            setPourcentage("")
            setDecision("")
            setConduite("")
            setIsLoading(false)
            Swal.fire(
                {
                    title:"Alert",
                    text:'Critère de délibération enregistré avec succès',
                    icon:'success',
                    timer:2000

                }
            )
        }).catch((err)=>{
            setIsLoading(false)
        })
    }else{
        setIsLoading(false)
        Swal.fire({
                title:"Alerte",
                text:"Vérifiez si vous avez complété le nombre des cours ainsi que son critère de test",
                icon:'error'

            })
    }
            
            
            
        
    }
    return(
        <>
           <div className="container ">
                <div className="row mt-2">
                    <div className="col-md-12">
                        <div className="form">
                            <h3 className="form-title text-primary">
                                Insertion Critères de déliberation : 
                            </h3>
                            <div className="row">
                                <div className="col-md-6 mx-auto">
                                    <div className="form-group mb-2">
                                        <div className="form-outline">
                                            <label htmlFor="type_deliberation" className="form-label">Section</label>

                                            <select className="form-select" id="section" name="section" onChange={(e)=>handleChangeSection(e)} value={section}>
                                                <option value="" selected disabled>Choix de la section</option>
                                                {sections?.map((sect,index)=>(
                                                    <option value={sect?.idsection} key={index}>{sect?.nom}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group mb-2">
                                        <div className="form-outline">
                                            <label htmlFor="type_deliberation" className="form-label">Niveau</label>
                                            <select name="niveau" id="niveau" className="form-select" onChange={(e)=>setNiveau(e.target.value)} value={niveau}>
                                                <option value="" selected disabled>Choix du niveau</option>
                                                {
                                                    !isEmpty(section) && section==="1" ? (
                                                        <>
                                                            <option value="7">7ème année</option>
                                                            <option value="8">8ème année</option>
                                                            
                                                        </>
                                                    ):(
                                                        <>
                                                            <option value="1">1ère année</option>
                                                            <option value="2">2ème année</option>
                                                            <option value="3">3ème année</option>
                                                            <option value="4">4ème année</option>
                                                        </>
                                                    )
                                                }
                                            </select>
                                        </div>
                                    </div>
                                   <hr />
                                    

                                </div>
                            </div>
                            <div className="row">
                                <p className="">ci-dessous configurer les critères de délibération des élèves de la {niveau}{prefixe(niveau)}{sectionnom?.nom} </p>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    Les élèves dont le pourcentage est :
                                </div>
                                <div className="col-md-6 mb-2">
                                    <select name="" id="" className="form-select" value={testpourcentage} onChange={(e)=>setTestpourcentage(e.target.value)} required>
                                        <option value="" selected disabled>Faites votre choix</option>
                                        <option value=">=">Supérieur ou égal</option>
                                        <option value="<=">Inférieur ou égal</option>
                                        <option value="entre">Entre</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    Pourcentage : 
                                </div>
                                <div className="col-md-6 mb-2">
                                    <input type="number" name="debut" className="form-control" value={pourcentage} onChange={(e)=>setPourcentage(e.target.value)} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    Et dont le :
                                </div>
                                <div className="col-md-6 mb-2">
                                    <select name="critere" id="" className="form-select" value={critere2} onChange={(e)=>setCritere2(e.target.value)}>
                                        <option value="" selected >Peu importe</option>
                                        <option value="NombreReussite">Nombre des réussites</option>
                                        <option value="NombreEchec">Nombre d'échec</option>
                                    </select>
                                </div>
                            </div>
                            {
                               !isEmpty(critere2) && 
                            
                            <div className="groupif">
                                <div className="row">
                                    <div className="col-md-6 mb-2">
                                        Est :
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <select name="" id="" className="form-select" value={testnombreCour} onChange={(e)=>setTestNombreCours(e.target.value)}>
                                            <option value="" selected disabled>Faites votre choix</option>
                                            <option value=">=">Supérieur ou égal</option>
                                            <option value="<=">Inférieur ou égal</option>
                                            
                                        </select>
                                    </div>
                                </div>
                            
                                <div className="row">
                                    <div className="col-md-6 mb-2">
                                        Nombre {prefixecritere(critere2)}
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <input type="number" name="nbrcrs" className="form-control" value={nombrecours} onChange={(e)=>setNombrecours(e.target.value)} />
                                    </div>
                                </div>
                    
                            </div>
                            }
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    Dont la conduite est : 
                                </div>
                                <div className="col-md-6 mb-2">
                                    <select name="conduite" id="conduite" className="form-select" value={conduite} onChange={(e)=>setConduite(e.target.value)}>
                                                <option value="">Peu importe</option>
                                                <option value="E">Excellent</option>
                                                <option value="TB">Très bonne Conduite</option>
                                                <option value="B">Bonne Conduite</option>
                                                <option value="M">Mauvaise Conduite</option>
                                                <option value="TM">Très mauvaise Conduite</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    <label htmlFor="nombreoption" className="form-label">Décision du jury :</label>
                                </div>
                                 <div className="col-md-6 mb-2">
                                    <div className="form-group">
                                        <div className="form-outline">
                                            <select name="decision" id="decision" className="form-select" value={decision} onChange={(e)=>setDecision(e.target.value)}>
                                                <option value="" selected disabled>Sélection de la décision</option>
                                                <option value="Réussite">Réussite</option>
                                                <option value="Rédouble">Rédouble</option>
                                                <option value="Seconde-session">Secondes sessions</option>
                                                <option value="Réussite-réorientation-ailleurs">Réussi mais réorienter ailleurs</option>
                                                <option value="Rédouble-réorientation-ailleurs">Rédouble et réorienter ailleurs</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2 mb-2">
                                <div className="col-md-12">
                                    <button type="button" className="btn btn-lg btn-primary" onClick={handleSend}>
                                        {
                                            isLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <span className="ml-2">En cours...</span>
                                                </>
                                            ) : (
                                                "Enregistrer"
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    )
}
export default Deliberation